import styled, { css } from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledFormPanel = styled.div<{ $isEditable: boolean; $notEditable: boolean }>`
    padding: 16px;
    margin-bottom: 30px;
    background-color: var(--color-white);
    border-radius: var(--radius-10);
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15);

    @media ${breakpoints.xs} {
        margin-bottom: 16px;
    }

    .subTitle {
        width: 80%;
        margin-bottom: 5px;
        font-size: var(--size-16);
        color: var(--color-grey-800);
        @media ${breakpoints.xs} {
            width: 100%;
            font-size: var(--size-12);
        }
    }

    .label {
        font-size: var(--size-16);
        font-weight: normal;
        @media ${breakpoints.sm} {
            min-width: 185px;
        }
        @media ${breakpoints.xs} {
            font-size: var(--size-12);
            line-height: 16px;
        }
    }

    .infoContainer {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
        @media ${breakpoints.xs} {
            display: block;
        }

        .label {
            margin-right: 10px;
            font-size: var(--size-16);
            font-style: normal;
            font-weight: normal;
            line-height: 20px;
            color: var(--color-grey-800);
            @media ${breakpoints.xs} {
                font-size: var(--size-12);
                line-height: 18px;
            }
        }

        p {
            margin: 0;
            font-size: var(--size-16);
            font-weight: bold;
            line-height: 22px;
            color: var(--color-grey-900);
            word-break: break-word;
            @media ${breakpoints.xs} {
                font-size: var(--size-14);
                line-height: 19px;
            }
        }
    }

    ${(props) =>
        props.$isEditable &&
        css`
            background-color: var(--color-secondary-light);
        `}

    ${(props) =>
        props.$notEditable &&
        css`
            box-shadow: none;
        `}
`;

export const StyledEditIcons = styled.div`
    display: flex;
    align-items: center;
`;

export const StyledH5 = styled.h5`
    margin: 0;
    font-size: var(--size-16);
    font-weight: var(--weight-600);
    line-height: 19px;
    color: var(--color-primary);
    text-transform: uppercase;
    @media ${breakpoints.xs} {
        font-size: var(--size-14);
    }
`;
